import { useProfile } from '@shared/api/useProfile';
import { useActiveProfileInfo } from '@entities/profile/lib/use-active-profile-info';
import { ProfileSwitcher } from '@widgets/profile-switcher/profile-switcher';
import { getAvatarUrl } from '@utils/lib/getAvatarUrl';
import s from './settings.module.scss'
import { IconChevronRight } from '@tabler/icons-react';
import { NavLink } from 'react-router-dom';
import useMedia from 'use-media';
import { PageTemplate } from '@shared/ui/page-template';
import { getFullName } from '@utils/lib/getFullname';
import { VideoSettings } from '@pages/settings/video-settings/video-settings';
import { Notifications } from '@pages/settings/notification-settings/notification';
import { UpdatePassword } from '@pages/settings/update-password/update-password';
import { AppearanceSettings } from '@pages/settings/appearance-settings';
import { ChildrenSettings } from '@pages/settings/children-settings';
import { ProfileSettings } from '@pages/settings/child-profile-settings/profile-settings';
import { Tab, Tabs } from '@shared/ui/tabs/tabs';
import { auth } from '@shared/api/services';
import { TimezoneButton } from '@features/profile/timezone';
import { SupportButton } from '@shared/ui/support-button';
import { version } from 'info';
import classNames from 'classnames';

// Детскому профилю недоступны разделы владельца (постановка «Родители и дети»):
// уведомления, безопасность (пароль аккаунта) и управление детьми.
const SETTINGS_TABS = [
	{ key: 'profile', label: 'Профиль', Component: ProfileSettings },
	{ key: 'video', label: 'Видео и Аудио', Component: VideoSettings },
	{ key: 'notifications', label: 'Уведомления', Component: Notifications, ownerOnly: true },
	{ key: 'security', label: 'Безопасность', Component: UpdatePassword, ownerOnly: true },
	{ key: 'appearance', label: 'Внешний вид', Component: AppearanceSettings },
	{ key: 'children', label: 'Дети', Component: ChildrenSettings, ownerOnly: true },
]

export const Settings = () => {
	const isMobile = useMedia({maxWidth: '768px'})
	const {data: profile} = useProfile()
	const { isChildMode, activeProfile, profiles } = useActiveProfileInfo()
	const tabs = SETTINGS_TABS.filter((tab) => !tab.ownerOnly || !isChildMode)

	// В детском режиме в шапке настроек показываем активный профиль, а не аккаунт родителя
	const displayName = activeProfile?.name ?? getFullName(profile)
	const displayAvatar = getAvatarUrl(activeProfile?.avatar ?? profile?.avatar)

	return (
		<PageTemplate title='Настройки'>
			{isMobile ? <div className={s.menu}>
				{profiles.length === 0 && (
					<div className={s.profile}>
						<div className={s.avatar}>
							<img src={displayAvatar} alt="" />
						</div>
						<div className={s.profileContent}>
							<div className={s.mail}>Профиль</div>
							<div className={s.name}>{displayName}</div>
						</div>
					</div>
				)}
				<div className={s.menuList}>
					<ProfileSwitcher menuDirection="down"/>
				</div>
				<div className={s.menuList}>
					<TimezoneButton/>
				</div>
				<div className={s.menuList}>
					<NavLink className={s.menuItem} to="./profile">Профиль<IconChevronRight size={16} color='#888'/></NavLink>
					<NavLink className={s.menuItem} to="./video-and-audio">Видео и аудио<IconChevronRight size={16} color='#888'/></NavLink>
					{!isChildMode && <NavLink className={s.menuItem} to="./notifications">Уведомления<IconChevronRight size={16} color='#888'/></NavLink>}
					{!isChildMode && <NavLink className={s.menuItem} to="./security">Безопасность<IconChevronRight size={16} color='#888'/></NavLink>}
					{!isChildMode && <NavLink className={s.menuItem} to="./children">Мои дети<IconChevronRight size={16} color='#888'/></NavLink>}
					<NavLink className={s.menuItem} to="./appearance">Внешний вид<IconChevronRight size={16} color='#888'/></NavLink>
					<NavLink className={s.menuItem} to="/info">Информация<IconChevronRight size={16} color='#888'/></NavLink>
				</div>
				<div className={s.menuList}>
					<SupportButton label="Написать в поддержку"
						// shape="pill"
						theme="secondary"
						buttonClassName={classNames(s.menuItem,s.supportButton)}/>
				</div>
				<div className={s.menuList}>
					<NavLink className={s.logout} onClick={() => auth.logout()}>Выйти</NavLink>
				</div>
				<div className={s.version}>Версия {version}</div>
			</div> : 
				<Tabs key={isChildMode ? 'child' : 'owner'} className={s.tabs} options={tabs.map(({ key, label }) => ({ key, label }))}>
					{tabs.map(({ key, Component }) => (
						<Tab key={key}>
							<Component/>
						</Tab>
					))}
				</Tabs>
			}
		</PageTemplate>
	)
}